angular.module('unergie.main')
.directive('popupconfirm', ($timeout, BarcodeService, CommonRegex, AlertManager) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/popupconfirm/popupconfirm.html',
        transclude: true,
        scope: {
            confirm: '&',
            onClose: '&',
            text: '=',
            buttonlabel: '=',
            placement: '=',
            template: '=',
            fields: '=',
            buttons: '=',
            removeDefaultButton: '=',
            enabled: '=',
            hover: '=',
            prevent: '=',
            remove: '=',
            fetching: '=',
            popoverClass: '=',
        },
        link($scope) {
            $scope.phoneRegex = CommonRegex.phone.mobiles
            $scope.phoneAllRegex = CommonRegex.phone.french
            $scope.phoneInternationalRegex = CommonRegex.phone.international
            $scope.emailsRegex = CommonRegex.email

            $scope.typeaheads = {}

            const initTypeAhead = () => {
                _.each($scope.fields, (v, k) => {
                    if (v.type === 'typeahead') {
                        $scope.typeaheads[k] = _.find(v.enum, { value: $scope.template[k] })
                    }
                })
            }

            $scope.emptyTypeahead = (k) => {
                $scope.typeaheads[k] = undefined
                $scope.template[k] = undefined
                if ($scope.fields[k].onSelect) {
                    $scope.fields[k].onSelect(null)
                }
            }

            $scope.typeaheadSelect = (k, value) => {
                $scope.template[k] = value
                if ($scope.fields[k].onSelect) {
                    $scope.fields[k].onSelect(value)
                }
            }

            $scope.dates = {}
            $scope.datesWatchers = []
            $scope.jsonObjects = {}
            $scope.jsonObjectsValidation = {}

            const watchDateTemplate = (fieldName) => {
                const template = $scope.template[fieldName]
                const date = $scope.dates[fieldName]
                if (template == null && date != null) {
                    $scope.dates[fieldName] = null
                    return
                }
                const field = $scope.fields[fieldName]
                const momentTemplate = moment(template, field.targetFormat)
                const momentDate = moment(date, field.parseFormat)
                if (momentTemplate.isValid() && (!momentDate.isValid() || momentTemplate.diff(momentDate))) {
                    $scope.dates[fieldName] = momentTemplate.format(field.parseFormat)
                }
            }

            $scope.initDateTemplate = (fieldName) => {
                const field = $scope.fields[fieldName]
                if (typeof field.min === 'string') {
                    const minString = field.min
                    field.min = () => minString
                }
                if (typeof field.max === 'string') {
                    const maxString = field.max
                    field.max = () => maxString
                }
                switch (field.type) {
                    case 'date':
                        field.parseFormat = 'DDMMYYYY'
                        field.targetFormat = field.targetFormat || 'YYYY-MM-DD'
                        break
                    case 'datetime':
                    default:
                        field.parseFormat = 'DDMMYYYYHHmm'
                        field.targetFormat = field.targetFormat || 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
                        break
                }
                $scope.dates[fieldName] = $scope.template[fieldName] && moment($scope.template[fieldName]).format(field.parseFormat)

                $scope.datesWatchers.push($scope.$watch(`template.${fieldName}`, () => watchDateTemplate(fieldName)))
            }

            $scope.updateDateTemplate = (fieldName) => {
                const field = $scope.fields[fieldName]

                const mDate = $scope.dates[fieldName] && moment($scope.dates[fieldName], field.parseFormat)
                let result = (Date.parse(mDate) && mDate.toDate()) || undefined

                const minDate = field.min && field.min($scope.template)
                const maxDate = field.max && field.max($scope.template)

                if (minDate && result && moment(result).isBefore(moment(minDate))) {
                    result = moment(minDate).toDate()
                    AlertManager.error(`La "${field.label}" doit être postérieure ou égale à ${moment(minDate).format('DD/MM/YYYY')}`, 8000)
                }
                if (maxDate && result && moment(result).isAfter(moment(maxDate))) {
                    result = moment(maxDate).toDate()
                    AlertManager.error(`La "${field.label}" doit être antérieure ou égale à ${moment(maxDate).format('DD/MM/YYYY')}`, 8000)
                }

                if (result) {
                    result = moment(result).format(field.targetFormat)
                    $scope.dates[fieldName] = moment(result).format(field.parseFormat)
                }

                $scope.template[fieldName] = result
            }

            $scope.datepickers = {}

            $scope.initDatePickerTemplate = (fieldName) => {
                if ($scope.template[fieldName]) {
                    $scope.datepickers[fieldName] = moment($scope.template[fieldName]).toDate()
                }
                const field = $scope.fields[fieldName]
                if (typeof field.min === 'string') {
                    const minString = field.min
                    field.min = () => minString
                }
                if (typeof field.max === 'string') {
                    const maxString = field.max
                    field.max = () => maxString
                }
                $scope.$watch(`template.${fieldName}`, () => {
                    $scope.datepickers[fieldName] = moment($scope.template[fieldName]).toDate()
                })
            }

            $scope.updateDatePickerTemplate = (field) => {
                const date = moment($scope.datepickers[field])
                $scope.template[field] = date.isValid() ? date.format('YYYY-MM-DD') : undefined
            }

            $scope.ok = function (e) {
                if ($scope.prevent && e) {
                    e.preventDefault()
                    e.stopPropagation()
                }
                if (!$scope.isDisabled()) {
                    $scope.opened = false
                    return $scope.confirm()
                }
            }

            $scope.executeActions = function (button) {
                if (!$scope.isDisabled()) {
                    $scope.opened = false
                    return button.execute()
                }
            }

            $scope.isDisabled = function () {
                if ($scope.fields) {
                    const requiredMissing = Object.keys($scope.fields).some((k) => {
                        const definition = $scope.fields[k]
                        const data = $scope.template && $scope.template[k]

                        if (definition.type === 'file' && $scope.required(k) && !$scope.hidden(k)) {
                            return data.queue.length < 1
                        }

                        // has to pass the field's check
                        if ($scope.fields[k].check && !$scope.fields[k].check($scope.template)) {
                            return true
                        }

                        return $scope.required(k) && ((data == null) || (data === '')) && !$scope.hidden(k)
                    })

                    if (requiredMissing) {
                        return true
                    }
                }

                return $scope.fields === false
            }

            $scope.required = (field) => {
                const { required } = $scope.fields[field]
                return _.isFunction(required) ? required($scope.template) : required
            }

            $scope.hidden = (field) => {
                const { hidden } = $scope.fields[field]
                return _.isFunction(hidden) ? hidden($scope.template) : hidden
            }

            $scope.label = (field) => {
                const label = $scope.fields[field].label || field
                return _.isFunction(label) ? label($scope.template) : label
            }

            $scope.placeholder = (field) => {
                const placeholder = $scope.fields[field].placeholder || $scope.fields[field].label || field
                return _.isFunction(placeholder) ? placeholder($scope.template) : placeholder
            }

            $scope.open = function (e) {
                if ($scope.prevent && e) {
                    e.preventDefault()
                    e.stopPropagation()
                }
                $scope.opened = true
                initTypeAhead()
            }


            $scope.$watch('opened', () => {
                if (!$scope.opened) {
                  // "unwatch" dates
                  $scope.datesWatchers.forEach((unwatcher) => unwatcher())
                  $scope.datesWatchers = []

                  if ($scope.onClose) {
                      return $scope.onClose()
                  }
                }
            })

            $scope.$watch('remove', () => {
                if ($scope.remove === true) {
                    $scope.opened = false
                }
            })

            $scope.removeFile = (item, e) => {
                e.preventDefault()
                e.stopPropagation()
                item.remove()
            }

            $scope.initJson = (field) => {
                if ($scope.template[field]) {
                    try {
                        $scope.jsonObjects[field] = JSON.stringify($scope.template[field], null, 4)
                        $scope.jsonObjectsValidation[field] = true
                    } catch (e) {
                        $scope.jsonObjectsValidation[field] = false
                    }
                } else if ($scope.required(field)) {
                    $scope.jsonObjectsValidation[field] = false
                }
            }

            $scope.validateJson = (field) => {
                if ($scope.jsonObjects[field]) {
                    try {
                        $scope.template[field] = JSON.parse($scope.jsonObjects[field])
                        $scope.jsonObjects[field] = JSON.stringify($scope.template[field], null, 4)
                        $scope.jsonObjectsValidation[field] = true
                    } catch (e) {
                        $scope.template[field] = null
                        $scope.jsonObjectsValidation[field] = false
                    }
                } else {
                    $scope.template[field] = null
                    if ($scope.required(field)) {
                        $scope.jsonObjectsValidation[field] = false
                    } else {
                        $scope.jsonObjectsValidation[field] = null
                    }
                }
            }
        },
    }))
